import {
  ADD_SKILL, EDIT_SKILL,
  SET_PRIORITIES,
  SET_QUALIFICATION,
  SET_CATEGORIES,
  SET_CODER_SKILL_LIST,
  ADD_TOKEN,
  DELETE_SKILL,
} from '../actionTypes';

export default function (state = {
  skillList: [],
  priorities: {},
  qualifications: {},
  jobCategories: {},
  token: '',
}, action) {
  switch (action.type) {
    case ADD_TOKEN: {
      // console.log(action.payload);
      return {
        ...state,
        token: action.payload,
      };
    }
    case SET_CODER_SKILL_LIST: {
      return {
        ...state,
        skillList: action.payload,
      };
    }
    case ADD_SKILL: {
      return {
        ...state,
        skillList: [
          ...state.skillList,
          action.payload,
        ],
      };
    }
    case DELETE_SKILL: {
      const filteredSkillList = state.skillList.filter((skill) => skill.id !== action.payload.id);
      return {
        ...state,
        skillList: filteredSkillList,
      };
    }
    case EDIT_SKILL: {
      const { parsedData, parsedData: { id } } = action.payload;
      const index = state.skillList.findIndex((item) => item.id === id);
      return {
        ...state,
        skillList: [...state.skillList.slice(0, index),
          parsedData,
          ...state.skillList.slice(index + 1)],
      };
    }
    case SET_PRIORITIES: {
      return {
        ...state,
        priorities: action.payload,
      };
    }
    case SET_QUALIFICATION: {
      return {
        ...state,
        qualifications: action.payload,
      };
    }
    case SET_CATEGORIES: {
      return {
        ...state,
        jobCategories: action.payload,
      };
    }
    default:
      return state;
  }
}
